import axios from "axios"

/**
 * Réclamer une remise :
 * ajoute le montant au soldeRemise de l'utilisateur connecté
 * avec les détails des types de remises appliquées
 */


/**
 * Obtenir son historique personnel de réclamations
 */
export const getMyDiscountHistory = async (): Promise<{
  success: boolean
  data: Array<{
    id: number
    totalAmount: number
    percentageDiscount: number
    pointsDiscount: number
    creditNoteDiscount: number
    usedPoints: number
    usedAvoirsIds: number[]
    createdAt: string
  }>
  count: number
}> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/solde/discount-history`
  const token = localStorage.getItem("token")

  if (!token) {
    return {
      success: false,
      data: [],
      count: 0
    }
  }

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    console.log("✅ Historique de remises:", response.data)

    return {
      success: true,
      data: response.data.data || [],
      count: response.data.count || 0
    }
  } catch (error: any) {
    console.error("❌ Erreur getMyDiscountHistory:", error)
    return {
      success: false,
      data: [],
      count: 0
    }
  }
}

/**
 * Obtenir tous les historiques (ADMIN)
 */
export const getAllDiscountClaims = async (): Promise<{
  success: boolean
  data: Array<{
    id: number
    userId: number
    user: { id: number; email: string; firstname: string; name: string }
    totalAmount: number
    percentageDiscount: number
    pointsDiscount: number
    creditNoteDiscount: number
    usedPoints: number
    usedAvoirsIds: number[]
    createdAt: string
  }>
  count: number
}> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/solde/discount-claims/all`
  const token = localStorage.getItem("token")

  if (!token) {
    return {
      success: false,
      data: [],
      count: 0
    }
  }

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    console.log("✅ Tous les historiques de remises:", response.data)

    return {
      success: true,
      data: response.data.data || [],
      count: response.data.count || 0
    }
  } catch (error: any) {
    console.error("❌ Erreur getAllDiscountClaims:", error)
    return {
      success: false,
      data: [],
      count: 0
    }
  }
}
export const claimDiscount = async (
  discountData: {
    totalAmount: number
    details: {
      percentageDiscount: number
      pointsDiscount: number
      creditNoteDiscount: number
      usedPoints: number
      usedAvoirsIds: number[]
    }
  }
): Promise<{
  success: boolean
  message: string
  soldeRemise?: number
}> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/solde/users/claim-discount`
  const token = localStorage.getItem("token")

  console.log("➡️ Discount Data :", discountData)

  if (!token) {
    console.warn("❌ Aucun token trouvé")
    return {
      success: false,
      message: "Utilisateur non authentifié",
    }
  }

  try {
    const response = await axios.post(
      apiUrl,
      discountData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    // ✅ LOG SUCCÈS
    console.log("✅ Réponse API claimDiscount :", response.data)

    return {
      success: true,
      message: response.data.message || "Remise réclamée avec succès",
      soldeRemise: response.data.soldeRemise,
    }
  } catch (error: any) {
    // ❌ LOG ERREUR DÉTAILLÉ
    console.error("❌ Erreur claimDiscount brute :", error)

    if (error.response) {
      console.error("📛 Status :", error.response.status)
      console.error("📛 Data :", error.response.data)
      console.error("📛 URL appelée :", error.config?.url)
    } else {
      console.error("📛 Erreur sans response (réseau ?) :", error.message)
    }

    let message = "Erreur lors de la réclamation de la remise."

    if (error.response) {
      if (error.response.status === 400) {
        message = error.response.data.message || "Montant invalide."
      } else if (error.response.status === 401 || error.response.status === 403) {
        message = "Vous n'êtes pas autorisé. Veuillez vous reconnecter."
      } else if (error.response.status === 404) {
        message = "Route introuvable (vérifier /solde/users/claim-discount)."
      }
    }

    return {
      success: false,
      message,
    }
  }
}

export const applySoldeRemise = async (userId: number, amount: number) => {
  console.log("applySoldeRemise called with userId:", userId, "and amount:", amount);
  const apiUrl = `${process.env.REACT_APP_API_URL}/solde/users/${userId}/use-solde-remise`;
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Utilisateur non authentifié");

  try {
    const response = await axios.post(apiUrl, { amount }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("Response from applySoldeRemise:", response.data);
    
    if (!response.data.success) throw new Error(response.data.message || "Erreur lors de l'utilisation du solde remise");

    return response.data.soldeRemise;
  } catch (error: any) {
    console.error("Erreur applySoldeRemise :", error);
    throw error;
  }
};

